// extracted by mini-css-extract-plugin
export default {"container":"LocationRequest_container__VnxNa","logo":"LocationRequest_logo__gl3Y-","button":"LocationRequest_button__ewbLL"};